import { useQueryClient } from "@tanstack/react-query";
import { useWahaSession } from "@/hooks/use-waha-session";
import type { WahaHealthStatus } from "@/hooks/use-waha-health-check";
import { Link } from "react-router-dom";
import { Loader2, WifiOff, ArrowRight } from "lucide-react";

export function WahaReconnectBanner() {
  const { data: session } = useWahaSession(false);
  const queryClient = useQueryClient();
  const healthStatus =
    queryClient.getQueryData<WahaHealthStatus>(["waha-health-status"]);

  // Rien a afficher si session OK ou pas de session
  if (!session) return null;
  if (session.status === "WORKING" && !healthStatus?.restarting) return null;

  // Reconnexion en cours
  if (healthStatus?.restarting) {
    return (
      <div className="flex items-center gap-2 px-4 py-2 bg-warning/10 border-b border-warning/20 text-warning text-xs">
        <Loader2 className="h-3.5 w-3.5 animate-spin shrink-0" />
        <span>Reconnexion WhatsApp en cours...</span>
      </div>
    );
  }

  // Session morte (STOPPED/FAILED) — restart echoue ou pas encore tente
  if (session.status === "STOPPED" || session.status === "FAILED") {
    return (
      <div className="flex items-center gap-2 px-4 py-2 bg-destructive/10 border-b border-destructive/20 text-destructive text-xs">
        <WifiOff className="h-3.5 w-3.5 shrink-0" />
        <span>WhatsApp deconnecte</span>
        <Link
          to="/settings"
          className="ml-auto flex items-center gap-1 text-primary hover:underline"
        >
          Reconnecter <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
    );
  }

  return null;
}
